<div fxLayoutAlign="center">
  <div class="video-container" [class.frame]="frame">
    <div class="video">
      <iframe [src]="src | safeUrl" frameborder="0" allow="accelerometer; autoplay; encrypted-media;" allowfullscreen>
      </iframe>
    </div>
  </div>
</div>
